import { Employee } from "~/gql/types";
import { FieldState, FormState } from "~/components/inline-fields-form/types";
import { ProjectRequestFolderType } from "./types";

const updateState = (
  state: FormState,
  updatedFields: Record<string, FieldState>
) => ({
  ...state,
  fields: {
    ...state.fields,
    ...updatedFields,
  },
});

const updateRequired = (
  state: FormState,
  field: string,
  required: boolean
) => ({
  [field]: { ...state.fields[field], required, error: "" },
});

const updateValue = (state: FormState, field: string) => ({
  [field]: { ...state.fields[field], value: null },
});

export const updater = {
  folderType: (state: FormState, value: ProjectRequestFolderType): FormState =>
    updateState(state, {
      ...updateRequired(
        state,
        "groupedFolder",
        window.config.featureFlags.projectFolders &&
          value == ProjectRequestFolderType.ExistingGrouped
      ),
      ...updateRequired(
        state,
        "jobsFolderDriveLetter",
        window.config.featureFlags.projectFolders &&
          value == ProjectRequestFolderType.Single
      ),
      ...updateRequired(
        state,
        "newGroupedFolderName",
        window.config.featureFlags.projectFolders &&
          value == ProjectRequestFolderType.NewGrouped
      ),
      ...updateRequired(
        state,
        "newGroupedFolderDriveLetter",
        window.config.featureFlags.projectFolders &&
          value == ProjectRequestFolderType.NewGrouped
      ),
    }),
  requestNewCustomer: (state: FormState, value: boolean): FormState =>
    updateState(state, {
      ...updateRequired(state, "customer", !value),
      ...updateRequired(state, "customerName", value),
      ...updateRequired(state, "customerAddress1", value),
      ...updateRequired(state, "customerCity", value),
      ...updateRequired(
        state,
        "customerCountry",
        value && state.fields.isInternational?.value
      ),
      ...updateRequired(
        state,
        "customerZip",
        value && !state.fields.isInternational?.value
      ),
      ...updateRequired(
        state,
        "customerState",
        value && !state.fields.isInternational?.value
      ),
      ...updateRequired(state, "customerPhone", value),
      ...updateValue(state, "groupedFolder"),
    }),
  isInternational: (state: FormState, value: boolean): FormState =>
    updateState(state, {
      ...updateRequired(state, "customerCountry", value),
      ...updateRequired(state, "customerZip", !value),
      ...updateRequired(state, "customerState", !value),
    }),
  customer: (state: FormState): FormState =>
    updateState(state, {
      ...updateValue(state, "groupedFolder"),
    }),
  projectManager: (state: FormState, value: Employee | null): FormState => {
    if (!value) {
      return state;
    }

    return {
      ...state,
      fields: {
        ...state.fields,
        officeCode: {
          ...state.fields.officeCode,
          value: value.fieldOffice || state.fields.officeCode.value,
        },
        jobsFolderDriveLetter: {
          ...state.fields.jobsFolderDriveLetter,
          value: value.defaultDrive || state.fields.jobsFolderDriveLetter.value,
        },
        newGroupedFolderDriveLetter: {
          ...state.fields.newGroupedFolderDriveLetter,
          value:
            value.defaultDrive ||
            state.fields.newGroupedFolderDriveLetter.value,
        },
      },
    };
  },
};
